import { render } from "./listplan_page.vue?vue&type=template&id=2a7566d0&scoped=true"
import script from "./listplan_page.vue?vue&type=script&lang=js"
export * from "./listplan_page.vue?vue&type=script&lang=js"

import "./listplan_page.vue?vue&type=style&index=0&id=2a7566d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7566d0"]])

export default __exports__